import { ActionReducer } from '@ngrx/store';

export function sessionStorageMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    const nextState = reducer(state, action);

    if (nextState.documents.documentPages) {
      sessionStorage.setItem('documentPages', JSON.stringify(nextState.documents.documentPages));
    }

    if (nextState.documents.openedTabIds) {
      sessionStorage.setItem('openedTabIds', JSON.stringify(nextState.documents.openedTabIds));
    }

    if (nextState.documents.activeTabId) {
      sessionStorage.setItem('activeTabId', JSON.stringify(nextState.documents.activeTabId));
    }

    return nextState;
  };
}
